import { render, staticRenderFns } from "./AttachInvoice.vue?vue&type=template&id=272a8630&"
import script from "./AttachInvoice.vue?vue&type=script&lang=js&"
export * from "./AttachInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports